const searchModal = {
  $modal: document.querySelector('.search_form_modal'),
  searchInputTimeout: null,
  searchAbortController: null,
  init() {
    if (this.$modal) {
      this.setUpListeners();
      this.setUpSearchSuggestions(this.$modal.querySelector('.search_form .input'));
    }
  },

  setUpListeners() {
    PubSub.subscribe('search.modal.toggle', this.toggleSearch.bind(this));
    PubSub.subscribe('search.modal.open', this.openSearchModal.bind(this));
    PubSub.subscribe('search.modal.close', this.closeSearchModal.bind(this));

    this.$modal
      .querySelector('.search_form .input')
      .addEventListener('input', ({target}) => {
        clearTimeout(this.searchInputTimeout);
        this.cancelSearchRequest();

        this.searchInputTimeout = setTimeout(() => {
          this.fetchSearchResults(target);
        }, 200);
      });

    this.$modal
      .addEventListener('click', ({target}) => {
        if (target.classList.contains('search_form_modal')
        || target.closest('.search_close')
        || target.classList.contains('cover')) {
          this.closeSearchModal();
        }
      });

    window.addEventListener('keydown', ({key}) => {
      if (key === 'Escape') {
        this.closeSearchModal();
      }
    });
  },

  openSearchModal() {
    this.$modal.classList.add('active');

    setTimeout(() => {
      this.$modal.querySelector('.search_form .input').focus();
    }, 100);
  },

  closeSearchModal() {
    clearTimeout(this.searchInputTimeout);
    this.cancelSearchRequest();
    this.$modal.classList.remove('active');
  },

  toggleSearch() {
    if (this.$modal.classList.contains('active')) {
      this.closeSearchModal();
    } else {
      this.openSearchModal();
    }
  },

  cancelSearchRequest() {
    if (this.searchAbortController) {
      this.searchAbortController.abort();
      this.searchAbortController = null;
    }
  },

  async fetchSearchResults(target) {
    const $resultsContainer = this.$modal.querySelector('.results_preview');
    const $results = $resultsContainer.querySelector('.results');
    const formData = new URLSearchParams();

    formData.append('action', 'tjh_quicksearch');
    formData.append('nonce', tjh.nonce);
    formData.append('search_query', target.value);

    if (tjh.lang) {
      formData.append('lang', tjh.lang);
    }

    $resultsContainer.classList.remove('show_loading', 'show_too_short', 'show_no_results');

    if (target.value && target.value.length > 2) {
      this.cancelSearchRequest();

      const abortController = new AbortController();
      this.searchAbortController = abortController;

      if (!$resultsContainer.classList.contains('show_loading')) {
        $resultsContainer.classList.add('show_loading');
      }

      try {
        const response = await fetch(tjh.ajax_url, {
          method: 'POST',
          body: formData,
          signal: abortController.signal,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const {data} = await response.json();

        this.updateSearchResults(data);
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        console.error('Error:', error);
      } finally {
        if (this.searchAbortController === abortController) {
          this.searchAbortController = null;

          if ($resultsContainer.classList.contains('show_loading')) {
            $resultsContainer.classList.remove('show_loading');
          }
        }
      }
    } else {
      this.cancelSearchRequest();
      // less than 2 letters were entered
      // clear the results
      $results.innerHTML = '';
      if (!$resultsContainer.classList.contains('show_too_short')) {
        $resultsContainer.classList.add('show_too_short');
      }

      if ($resultsContainer.classList.contains('show_results')) {
        $resultsContainer.classList.remove('show_results');
      }
    }
  },

  updateSearchResults(list) {
    const $resultsContainer = this.$modal.querySelector('.results_preview');
    const $results = $resultsContainer.querySelector('.results');
    const items = [];

    if (list && list.length) {
      list.forEach(({link, title}) => {
        const $item = document.createElement('A');
        $item.setAttribute('href', link);
        $item.classList.add('result');
        $item.innerHTML = title;

        items.push($item);
      });

      if (items.length) {
        $results.innerHTML = '';
        items.forEach($item => $results.append($item));

        if ($resultsContainer.classList.contains('show_no_results')) {
          $resultsContainer.classList.remove('show_no_results');
        }

        if (!$resultsContainer.classList.contains('show_results')) {
          $resultsContainer.classList.add('show_results');
        }
      }
    } else {
      if (!$resultsContainer.classList.contains('show_no_results')) {
        $resultsContainer.classList.add('show_no_results');
      }

      if ($resultsContainer.classList.contains('show_results')) {
        $resultsContainer.classList.remove('show_results');
      }
    }
  },

  setUpSearchSuggestions($input) {
    const suggestions = JSON.parse($input.getAttribute('data-suggestions')); // Parse JSON data
    const phrases = suggestions.map(s => s.word); // Extract words from the array
    const steps = [phrases[0]];

    // Build steps for typing and erasing animation
    for (let i = 0; i < phrases.length; ) {
      const current = steps[steps.length - 1];
      const nextPhrase = phrases[(i + 1) % phrases.length];
      if (nextPhrase === current) {
        i++;
      } else if (nextPhrase.startsWith(current)) {
        steps.push(current + nextPhrase[current.length]);
      } else {
        steps.push(current.slice(0, -1));
      }
    }

    // Animation function
    const animate = index => {
      setTimeout(() => {
        $input.setAttribute('placeholder', steps[index]);
        const nextIndex = (index + 1) % steps.length;
        if (steps[nextIndex].length > steps[index].length) {
          animate(nextIndex); // Continue typing
        } else {
          setTimeout(() => {
            const erase = i => {
              setTimeout(() => {
                $input.setAttribute('placeholder', steps[i]);
                const nextEraseIndex = (i + 1) % steps.length;
                if (steps[nextEraseIndex].length > steps[i].length) {
                  animate(nextEraseIndex); // Switch back to typing
                } else {
                  erase(nextEraseIndex); // Continue erasing
                }
              }, 65); // Typing speed
            };
            erase(nextIndex);
          }, 2500); // Pause before erasing
        }
      }, 110 + 60 * Math.random()); // Natural typing delay
    };

    animate(0); // Start the animation
  }
};

export default searchModal;